import { createContext, useState } from 'react';

const MemoryContext = createContext();

export const MemoryContextProvider = ({ children }) => {

    const [memoryData, setMemoryData] = useState({});

    const valuesToShare = {
        memoryData,
        setMemoryData
    }

    return (
        <MemoryContext.Provider
            value={valuesToShare}
        >
            {children}
        </MemoryContext.Provider>
    )
}

// Export context for use outside the feature
export default MemoryContext;